import { TweenMax, TimelineMax } from 'gsap';
import * as React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFShopify from '@/components/UI/svg/river2/Icon/EFShopify';
import EFGeneratorSolar from '@/components/UI/svg/river2/Icon/EFGeneratorSolar';
import EFGeneratorFaster from '@/components/UI/svg/river2/Icon/EFGeneratorFaster';
import EFGeneratorIP68 from '@/components/UI/svg/river2/Icon/EFGeneratorIP68';
import EFGenerator10 from '@/components/UI/svg/river2/Icon/EFGenerator10';
import EFGeneratorEasily from '@/components/UI/svg/river2/Icon/EFGeneratorEasily';
import EFGeneratorSaving from '@/components/UI/svg/river2/Icon/EFGeneratorSaving';
import EFVideo from '@/components/UI/EFVideo';
import { SHOW_RIVER2_OPTIMIZATION } from '@/constants';

const ZA_IMG = {
    H1: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682071514/r2p_h1_1366_za.jpg',
    H2: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682098073/r2p_h2_1366_za.jpg',
    H4: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682106435/r2p_h3_1366_za.jpg',
    H3: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682112549/r2p_h4_1366_za.jpg',
    H5: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682120262/r2p_h5_1366_za.jpg',
    H6: 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711682125999/r2p_h6_1366_za.jpg',
};
const { EFPic } = createEFPic('');
const App: React.FunctionComponent = (props) => {
    const { useEffect, useState, useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('productriver2');
    const [showDialog, setShowDialog] = useState(false);

    const dialogList1: any = [
        {
            icon: <EFGeneratorSolar />,
            text: t('river2.details.sec8_list1_text1'),
        },
        {
            icon: <EFGeneratorFaster />,
            text: t('river2.details.sec8_list1_text2'),
        },
        {
            icon: <EFGeneratorIP68 />,
            text: t('river2.details.sec8_list1_text3'),
        },
        {
            icon: <EFGeneratorEasily />,
            text: t('river2.details.sec8_list1_text4'),
        },
        {
            icon: <EFGenerator10 />,
            text: t('river2.details.sec8_list1_text5'),
        },
        {
            icon: <EFGeneratorSaving />,
            text: t('river2.details.sec8_list1_text6'),
        },
    ];

    const dialogList2: any = [
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471885/1.png'
                    : ['/media/river2/pc/river2_110w.webp', '/media/river2/pc/river2_110w.png'],
            text: t('river2.details.sec8_list2_text1'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-solar-generator-110w-solar-panel',
                mx: 'https://mx.ecoflow.com/products/generator-river-2-110w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-110w-portable-solar-panel${locale === 'ca' ? '?variant=42680870994074' : ''}`,
            },
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471489/2.png'
                    : ['/media/river2/pc/river2max_160w.webp', '/media/river2/pc/river2max_160w.png'],
            text: t('river2.details.sec8_list2_text2'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-max-solar-generator-160w-solar-panel',
                cn: 'https://item.jd.com/10061057781058.html#crumb-wrap',
                mx: 'https://mx.ecoflow.com/products/generator-ecoflow-river-2-max-160w-solar-panel',
                ph: 'https://ph.ecoflow.com/products/ecoflow-river-2-max-160w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-max-160w-portable-solar-panel${locale === 'ca' ? '?variant=42680871026842' : ''}`,
            },
        },
        {
            img:
                locale === 'ph'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1752228471683/3.png'
                    : ['/media/river2/pc/river2pro_220w.webp', '/media/river2/pc/river2pro_220w.png'],
            text: t('river2.details.sec8_list2_text3'),
            link: {
                jp: 'https://jp.ecoflow.com/products/river-2-pro-solar-generator-220w-solar-panel',
                cn: 'https://item.jd.com/10061057574837.html#crumb-wrap',
                mx: 'https://mx.ecoflow.com/products/generator-delta-2-220w-portable-solar-panel',
                ph: 'https://ph.ecoflow.com/products/ecoflow-river-2-pro-220w-solar-panel',
                local: `https://${locale}.ecoflow.com/products/river-2-pro-220w-portable-solar-panel${locale === 'ca' ? '?variant=42680871125146' : ''}`,
            },
        },
    ];

    if (locale === 'cn') {
        dialogList2.shift();
    }

    const onSolarPanel = (list: any) => {
        window.open(list?.link[locale] || list?.link?.local, '_blank');
    };

    let ctl: any;
    let ScrollMagic: any;
    const [isEnterA, setIsEnterA] = useState(false);

    useEffect(() => {
        ScrollMagic = (window as any).ScrollMagic;
        ctl = new ScrollMagic.Controller();
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_H .photo-list',
            triggerHook: 1,
            offset: 0,
            duration: 700,
        });
        const timelineA1 = new TimelineMax();
        const tweenA1 = TweenMax.to('.river2_detials_H .photo-item.car .photo-item-in', 0.5, {
            y: 110,
            ease: 'none',
        });
        const tweenA2 = TweenMax.to('.river2_detials_H .photo-item.solar .photo-item-in', 0.5, {
            y: 225,
            ease: 'none',
        });
        const tweenA3 = TweenMax.to('.river2_detials_H .photo-item.generator .photo-item-in', 0.5, {
            y: 110,
            ease: 'none',
        });
        if (getRiver2Optimization()) {
            timelineA1.add(tweenA1, 0).add(tweenA2, 0).add(tweenA3, 0);
        } else {
            timelineA1.add(tweenA1, 0).add(tweenA2, 0);
        }
        sceneA1.setTween(timelineA1);
        ctl.addScene(sceneA1);
    }, []);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.river2_detials_H .photo-scale-box',
            triggerHook: 0.1,
            offset: 0,
            duration: '200%',
        });
        sceneA1.on('enter', () => {
            setIsEnterA(true);
        });
        sceneA1.on('leave', () => {
            setIsEnterA(false);
        });
        ctl.addScene(sceneA1);
    }, []);

    const onClickOutside = (e: any) => {
        if (['generatorModal show', 'mask', 'wrapper'].includes(e?.target?.className)) {
            setShowDialog(false);
        }
    };

    const getRiver2Optimization = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
            return true;
        }
        return false;
    };

    const getOptimizationDesc = () => {
        if (SHOW_RIVER2_OPTIMIZATION.includes(locale)) {
            return {
                title: t('river2.details.sec8_optimize_title'),
                desc: t('river2.details.sec8_optimize_desc'),
            };
        }
        return {
            title: t('river2.details.sec8_title'),
            desc: t('river2.details.sec8_desc'),
        };
    };

    return (
        <>
            <div className={`${css.H_8} river2_detials_H ${isEnterA ? ' isEnterA' : ''}`}>
                <div className="header-block-box"></div>
                <div className="content-box">
                    <div className="title-box">{getOptimizationDesc().title}</div>
                    <div className="change-box">{t('river2.details.sec8_change')}</div>
                    <div className="desc-box">{getOptimizationDesc().desc}</div>
                </div>
                <div className={`photo-list`}>
                    <div className="photo-scale-box">
                        <div className="photo-item photo-item-opacity AC">
                            <div className="photo-item-in">
                                <div className="image-box">
                                    <EFPic
                                        name={
                                            locale === 'ph'
                                                ? 'https://websiteoss.ecoflow.com/upload/image/1751079780593/6-3.jpg'
                                                : locale === 'za'
                                                ? ZA_IMG.H1
                                                : ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph'].includes(locale)
                                                ? ['/media/river2/pc/H2_eu.jpg', '/media/river2/pc/H2_eu.jpg']
                                                : ['/media/river2/pc/H2.webp', '/media/river2/pc/H2.jpg']
                                        }
                                        alt={t('river2.details.sec8_AC')}
                                        aria-label={t('river2.details.sec8_AC')}
                                    />
                                </div>
                                <div className="produce-name">{t('river2.details.sec8_AC')}</div>
                            </div>
                        </div>
                        <div className="photo-item photo-item-opacity car">
                            <div className="photo-item-in">
                                <div className="image-box">
                                    <EFPic
                                        name={
                                            locale === 'ph'
                                                ? 'https://websiteoss.ecoflow.com/upload/image/1751079780832/6-2.jpg'
                                                : locale === 'za'
                                                ? ZA_IMG.H2
                                                : ['/media/river2/pc/H4.webp', '/media/river2/pc/H4.jpg']
                                        }
                                        alt={t('river2.details.sec8_Car')}
                                        aria-label={t('river2.details.sec8_Car')}
                                    />
                                </div>
                                <div className="produce-name">{t('river2.details.sec8_Car')}</div>
                            </div>
                        </div>
                        <div className="photo-item solar">
                            <div className="photo-item-in">
                                <div className="photo-item-in-a">
                                    <div className="image-box solar-image-box">
                                        <div className="image-box__rel">
                                            <EFPic
                                                name={
                                                    locale === 'ph'
                                                        ? 'https://websiteoss.ecoflow.com/upload/image/1751079781206/6-5.jpg'
                                                        : locale === 'za'
                                                        ? ZA_IMG.H6
                                                        : ['/media/river2/pc/H5.webp', '/media/river2/pc/H5.jpg']
                                                }
                                                alt={t('river2.details.sec8_Solar')}
                                                aria-label={t('river2.details.sec8_Solar')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="produce-name">{t('river2.details.sec8_Solar')}</div>
                            </div>
                        </div>
                        {getRiver2Optimization() && (
                            <div className="photo-item photo-item-opacity generator">
                                <div className="photo-item-in">
                                    <div className="image-box">
                                        <EFPic
                                            name={
                                                locale === 'za'
                                                    ? ZA_IMG.H4
                                                    : ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph'].includes(locale)
                                                    ? ['/media/river2/pc/H1_eu.jpg', '/media/river2/pc/H1_eu.jpg']
                                                    : ['/media/river2/pc/H6.webp', '/media/river2/pc/H6.png']
                                            }
                                            alt={t('river2.details.sec8_Generator_c')}
                                            aria-label={t('river2.details.sec8_Generator_c')}
                                        />
                                    </div>
                                    <div className="produce-name">{t('river2.details.sec8_Generator_c')}</div>
                                </div>
                            </div>
                        )}
                        <div className="photo-item photo-item-opacity typec">
                            <div className="photo-item-in">
                                <div className="image-box">
                                    <EFPic
                                        name={
                                            locale === 'ph'
                                                ? 'https://websiteoss.ecoflow.com/upload/image/1751079781017/6-4.jpg'
                                                : locale === 'za'
                                                ? ZA_IMG.H5
                                                : ['eu', 'uk', 'de', 'fr', 'it', 'es', 'kr', 'ph'].includes(locale)
                                                ? ['/media/river2/pc/H1_eu.jpg', '/media/river2/pc/H1_eu.jpg']
                                                : ['/media/river2/pc/H1.webp', '/media/river2/pc/H1.jpg']
                                        }
                                        alt={t('river2.details.sec8_Typc')}
                                        aria-label={t('river2.details.sec8_Typc')}
                                    />
                                </div>
                                <div className="produce-name">{t('river2.details.sec8_Typc')}</div>
                            </div>
                        </div>
                        {!getRiver2Optimization() && (
                            <div className="photo-item photo-item-opacity photo-item-none">
                                <div className="photo-item-in"></div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="details-box">
                    <div className="details-text">
                        {t.rich('river2.details.sec8_product_details', {
                            p1: (child: React.ReactNode) => <div className="title-p1">{child}</div>,
                            p2: (child: React.ReactNode) => <span className="title-p2">{child}</span>,
                        })}
                    </div>
                    {['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn', 'br', 'mx', 'ph'].includes(locale) && (
                        <div className="generatorBox">
                            <div className="generator" onClick={() => setShowDialog(true)}>
                                <div className="text">{t('river2.details.sec8_generator')}</div>
                                <div className="plusIcon">+</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className={`generatorModal ${showDialog ? 'show' : 'hide'}`} onClick={onClickOutside}>
                    <div className="mask"></div>
                    <div className="wrapper">
                        <div className="content">
                            <div className="close" onClick={() => setShowDialog(false)}>
                                &times;
                            </div>
                            <div className="bannerImg">
                                <EFVideo
                                    width={'100%'}
                                    height={'100%'}
                                    sources={[
                                        `/video/river2/details/generator_${
                                            locale === 'ph'
                                                ? 'eu'
                                                : ['us', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn'].includes(locale)
                                                ? locale
                                                : locale === 'sa'
                                                ? 'uk'
                                                : 'us'
                                        }.webm`,
                                        `/video/river2/details/generator_${
                                            locale === 'ph'
                                                ? 'eu'
                                                : ['us', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'jp', 'cn'].includes(locale)
                                                ? locale
                                                : locale === 'sa'
                                                ? 'uk'
                                                : 'us'
                                        }.mp4`,
                                    ]}
                                />
                            </div>
                            <div className="innerBox">
                                <p className="textTop">{t('river2.details.sec8_generator_text1')}</p>
                                <ul className="iconLists">
                                    {dialogList1?.map((list: any, k: number) => (
                                        <li className="list1Box" key={`list1_${k}`}>
                                            <div className="list1Icon">{list?.icon}</div>
                                            <div className="list1Text">{list?.text}</div>
                                        </li>
                                    ))}
                                </ul>
                                <p className="textBottom">{t('river2.details.sec8_generator_text2')}</p>
                                <ul className="productLists">
                                    {dialogList2?.map((list: any, k: number) => (
                                        <li className="list2Box" key={`list2_${k}`}>
                                            <div className="list2Img">
                                                <EFPic name={list.img} alt={list?.text} className="fullImgs" />
                                            </div>
                                            <div className="list2Text">{list?.text}</div>
                                            <div className="list2Btn" onClick={() => onSolarPanel(list)}>
                                                <div className="btnIcon">
                                                    <EFShopify />
                                                </div>
                                                <div className="btnText">{t('river2.details.sec8_store')}</div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                <p className="note">{t('river2.details.sec8_generator_text3')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default App;
